<template>
  <v-container>
    <v-form v-model="valid">
      <v-container>
        <v-layout>
          <v-flex>
            <!-- USUARIOS -->
            <grid-usuario
              :key="proveedorUsuarioGrid"
              :tipoUsuario="'AGENCIA'"
            ></grid-usuario>
            <v-spacer></v-spacer>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import GridUsuario from "@/modules/configuration/gestionUsuario/views/GridUsuario.vue";

export default {
  components: {
    GridUsuario,
  },
  mixins: [validationMixin],
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    tabSelected: "",
  },
  data() {
    return {
      gridHidden: false,
      contratoId: "",
      proveedorUsuarioGrid: 0,
      agenciaUsuarioGrid: 10,
      proveedorContactoGrid: 20,
      agenciaContactoGrid: 30,
      allowSpaces: false,
      valid: false,
      contactosAgenc: [],
      contactosProv: [],
      usuariosAgenc: [],
      usuariosProv: [],
      razonSocial: "",
      rut: "",
      direccion: "",
      regiones: "",
      comunas: "",
      nombre: "",
      regionesSelect: [],
      comunasSelect: [],
      contrato: [],
      //usuarios: [],
      loading: true,
      tipoUsuario: "",
    };
  },
  validations: {
    rut: { required, maxLength: maxLength(10) },
    regiones: { required },
    razonSocial: { required },
    direccion: { required },
    comunas: { required },
    nombre: { required },
  },
  computed: {},

  mounted() {},
  created() {
    //IGUAL ACA NO SE USA
    this.userlogged = this.$store.getters.userLogged.tipo;
    if (this.userlogged == "ADMINISTRADOR") {
      this.gridHidden = true;
    } else {
      this.gridHidden = false;
    }

    if (
      this.contratoId != null &&
      this.contratoId != "" &&
      this.contratoId !== undefined
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    }
  },
  methods: {
    reloadAgenciaContact() {
      this.agenciaContactoGrid += 1;
    },

    reloadProveedorContact() {
      this.proveedorContactoGrid += 10;
    },

    reloadAgenciaUser() {
      this.agenciaUsuarioGrid += 20;
    },

    reloadProveedorUser() {
      this.proveedorUsuarioGrid += 30;
    },
  },
};
</script>
